import md5 from 'md5'

export default {
  async initialize({state, actions}) {
  }
}
